import React from 'react';

// These media assets may later be loaded by Fabric and drawn onto an exportable
// canvas, so they must always be requested with CORS enabled.
//
// If a form renders the same URL without `crossOrigin`, Cloudflare may cache a
// response without `Access-Control-Allow-Origin`. Fabric can then receive that
// cached response when it requests the image with CORS, causing the load to fail.
//
// Use this component for every image served from the media bucket so all requests
// are canvas-compatible.
export const MediaImage: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = props => (
  <img alt='' crossOrigin='anonymous' {...props} />
);
